import {Box, Text} from '@chakra-ui/react';
import React, {useRef} from 'react';
import {FileDrop} from 'react-file-drop';
import '../../styles/reports.css';
// needs a state, setState, inputRef and handleChange function to pass files from component up into where it is called from. Needs to pass into an array object. Does not work otherwise
export const FileDropper = props => {
  const fileInputRef = useRef('');
  const updateState = files => {
    const newFiles = files;
    props.setState(newFiles);
    props.handleChange(newFiles);
    props.inputRef.current = files;
  };

  const onFileInputChange = event => {
    const files = event.target.files;
    updateState(files);
  };

  const onTargetClick = () => {
    fileInputRef.current.click();
  };

  return (
    <div>
      <Box m={props.m ? props.m : 2} p={props.p ? props.p : 2} alignItems="center" style={{border: '2px dashed #0c5f78'}}>
        <FileDrop onDrop={files => updateState(files)} onTargetClick={onTargetClick} id="fileInput">
          {' '}
          {/* To edit the visuals of the dropper, you need to go to the bottom of the reports.css file. The dropper target is the actual size of the drag and drop.  */}
          Drop your file here or click me to select a file
          {props.state == ''
            ? ''
            : props.state.map((element, idx) => {
                return (
                  <Text key={idx} color={'#0c5f78'} fontSize="2xl">
                    {element.name}
                  </Text>
                );
              })}
        </FileDrop>
      </Box>
      <input
        onChange={onFileInputChange}
        ref={fileInputRef}
        type="file"
        style={{display: 'none'}}
        multiple={props.multiple ? props.multiple : false}
      />
    </div>
  );
};
